export const FILE_CONFIG = {
  UPLOAD: {
    MAX_SIZE: 5 * 1024 * 1024, // 5MB
    MIME_TYPES: [
      'image/jpeg',
      'image/png',
      'image/gif',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.pdf', '.doc', '.docx'],
    ERROR_MESSAGES: {
      SIZE: 'Размер файла не должен превышать 5MB',
      TYPE: 'Неподдерживаемый тип файла'
    }
  }
} as const;

// Update types to include EXTENSIONS
export type AllowedMimeTypes = typeof FILE_CONFIG.UPLOAD.MIME_TYPES[number];
export type AllowedExtensions = typeof FILE_CONFIG.UPLOAD.EXTENSIONS[number];

export interface FileConfig {
  UPLOAD: {
    MAX_SIZE: number;
    MIME_TYPES: readonly string[];
    EXTENSIONS: readonly string[];
    ERROR_MESSAGES: {
      SIZE: string;
      TYPE: string;
    };
  };
}